import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faBorderAll,
  faCheckCircle,
  faCog,
  faExclamationCircle,
  faFile,
  faFileAlt,
  faFolder,
  faFileInvoice,
  faPenAlt,
  faSync,
  faUserPlus,
  faEngineWarning,
  faVideo,
} from "@fortawesome/pro-light-svg-icons";

library.add(
  faBorderAll,
  faCheckCircle,
  faCog,
  faExclamationCircle,
  faFile,
  faFileAlt,
  faFileInvoice,
  faFolder,
  faPenAlt,
  faSync,
  faUserPlus,
  faEngineWarning,
  faVideo,
);



// WEBPACK FOOTER //
// ./src/fontawesome/light.js